// extracted by mini-css-extract-plugin
export default {"modalContent":"ModalContent-modalContent-bdTLe","closeButton":"ModalContent-closeButton-GYCdL"};